import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import Image from "next/image";
import { RelatedBlogPost } from "@/types/contentful/blog";
import { Link } from "@/i18n/routing";

interface BlogCardProps {
  item: RelatedBlogPost;
  index: number;
}

const RelatedBlogCard = ({
  item,
  index
}: BlogCardProps ) => (<Link
    href={item.url ?? ""}
    data-testid={`${item.id}_related-post-link`}
    style={{
      borderRadius: "20px"
    }}
  >
    <Stack
      sx={{
        width: "300px",
        borderRadius: "20px",
        overflow: "hidden",
        bgcolor: "background.default",
        boxShadow: 6,
        border: "1px solid",
        borderColor: "divider"
      }}
      data-card-name={item.title}
      data-carousel-position={index + 1}
    >
      <Box
        sx={{
          width: "300px",
          height: "200px",
          overflow: "hidden",
          position: "relative"
        }}
        data-testid={`${item.id}_related-post-image`}
      >
        {item?.heroImage && (
          <Image
            src={`${item?.heroImage?.url}`}
            alt={item?.title}
            width={300}
            height={200}
            loading="lazy"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover"
            }}
          />
        )}
      </Box>
      <Stack spacing={item?.publishedDate ? "2rem" : 0} sx={{ padding: "2rem", minHeight: item?.publishedDate ? "14rem" : "10.2rem", justifyContent: "space-between" }}>
        <Typography
          data-testid={`${item.id}_related-post-title`}
          component="p"
          sx={{
            fontSize: "14px",
            fontWeight: 600,
            color: "text.primary",
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }}
        >
          {item?.title}
        </Typography>

        { item?.publishedDate && (
          <Typography
            data-testid={`${item.id}_related-post-formatted-date`}
            component="p"
            sx={{
              fontSize: "12px",
              fontWeight: 600,
              color: "text.secondary"
            }}
          >
            {item?.publishedDate}
          </Typography>
        )}       
      </Stack>
    </Stack>
  </Link>
);

export default RelatedBlogCard;